import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Stack, Button } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import LogoutIcon from '@mui/icons-material/Logout';
import { useFullScreen } from '../../../../services/hooks';

import { setToken } from '../../../../services/redux-actions';

import { Logo } from '../../../../components/landing/Logo';
import { logoutAction } from '../../../../services/request';
import { useMutation } from 'react-fetching-library';

const Header = () => {
  const matches = useMediaQuery('(min-width:768px)');
  const { mutate } = useMutation(logoutAction);
  const { group } = useSelector(state => state.app);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = async () => {
    const { error } = await mutate();
    if (!error) {
      dispatch(setToken(null));
      navigate('/');
    }
  };

  return (
    <header>
      <Stack direction={!useFullScreen() ? 'row' : 'column'} justifyContent="space-between" alignItems="center" p={2} sx={{
        background: 'linear-gradient(90deg, #1256A7 0%, #44B9D6 100%)'
      }}>
        <Logo />
        <div style={{ display: 'flex', flexDirection: matches ? 'row' : 'column', gap: '16px' }}>
          {group == 'clients' && <Button variant="contained" color="info" href="https://sun-sport.pl/lato/strefa-promocji/" target="_blank" rel="noreferrer noopener" style={{ color: 'white', textAlign: 'center' }}>Aktualne promocje</Button>}
          <Button variant="contained" endIcon={<LogoutIcon />} onClick={handleLogout} color="secondary">wyloguj</Button>
          {useFullScreen() ? <Button style={{ color: 'white' }} variant="contained" component={RouterLink} to="/lato" target="_blank">
            Lato
          </Button> : null }
        </div>
      </Stack>
    </header>
  );
};

export default Header;
